import { ComponentType, createContext, ReactNode, useContext } from 'react';

import type { PersonTileProps } from '../components/PersonTile';

/**
 * Optional UI injected into the family tree by a host (e.g. the presentation
 * designer). Keeps presentation-specific components out of the generic family
 * tree: the tree just renders whatever slots it's given.
 */
export interface FamilyTreeSlots {
  /**
   * Replaces the plain person tile (wrapping `PersonTileBase`). Used by every
   * tile render site — standalone individuals, marriage-group spouses, and
   * ex-spouses — so e.g. the presentation's hover/edit treatment covers them
   * all. Defaults to the plain tile.
   */
  PersonTile?: ComponentType<PersonTileProps>;
  /** Node-edit drawer, rendered inside the provider while the side panel is open. */
  nodeEditDrawer?: ReactNode;
}

const FamilyTreeSlotsContext = createContext<FamilyTreeSlots>({});

export const FamilyTreeSlotsProvider = FamilyTreeSlotsContext.Provider;

export function useFamilyTreeSlots(): FamilyTreeSlots {
  return useContext(FamilyTreeSlotsContext);
}
